<ng-container [formGroup]="metadataFormGroup">
  <div class="row row-cols-md-2 row-cols-sm-1 form-group">
    <div class="col">
      <label>Nombre d'adultes</label>
      <input
        class="form-control"
        formControlName="adultsCount"
        type="number"
        min="0"
      />
    </div>
    <div class="col">
      <label>Nombre d'enfants</label>
      <input
        class="form-control"
        formControlName="childrenCount"
        type="number"
        min="0"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1">
    <div class="col">
      <label>Date de début d'assurance</label>
      <input
        class="form-control"
        [(ngModel)]="startDate"
        name="startDate"
        type="date"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>
</ng-container>
